import { MISCELLANEOUS_RESOURCES, PAGE_NAMES } from 'constant';
import confiscationAndRefund from 'assets/settings/role.png';
import CreateConfiscationAndRefund from '../create/Create';
import CreateBulkConfiscationAndRefund from '../bulkCreate/Create';

export const CONFISCATION_RESOURCES = {
	manualConfiscation: 'manualConfiscation',
	bulkConfiscation: 'bulkConfiscation'
};

export const URL = {
	[CONFISCATION_RESOURCES.manualConfiscation]: `/${PAGE_NAMES.miscellaneous}/${MISCELLANEOUS_RESOURCES.confiscationAndRefund}/selectConfiscation/${CONFISCATION_RESOURCES.manualConfiscation}`,
	[CONFISCATION_RESOURCES.bulkConfiscation]: `/${PAGE_NAMES.miscellaneous}/${MISCELLANEOUS_RESOURCES.confiscationAndRefund}/selectConfiscation/${CONFISCATION_RESOURCES.bulkConfiscation}`
};

export const LABEL = {
	[CONFISCATION_RESOURCES.manualConfiscation]: `Manual Confiscation`,
	[CONFISCATION_RESOURCES.bulkConfiscation]: `Bulk Confiscation`
};

export const COMPONENT = {
	[CONFISCATION_RESOURCES.manualConfiscation]: CreateConfiscationAndRefund,
	[CONFISCATION_RESOURCES.bulkConfiscation]: CreateBulkConfiscationAndRefund
};

export const IMAGE_SOURCE = {
	[CONFISCATION_RESOURCES.manualConfiscation]: confiscationAndRefund,
	[CONFISCATION_RESOURCES.bulkConfiscation]: confiscationAndRefund
};
